<template>
    <div id="topbar" class="bg-profile">
        <div id="topbar_wrapper">
            <div id="topbar_close"
                @click="clickBack()">
                <img src="../../../assets/icon/ic_back_gray.svg" />
            </div>
            <div id="topbar_title">{{title}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TopBarProfile',
    props: {
        title: String
    },
    methods: {
        clickBack: function () {
            this.$emit('clickBack');
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import './TopBarMain.scss';
</style>
